/*  @flow */
import * as React from 'react';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';

import {
  auditLocation,
  editLocation,
  updateAssignUsersToLocation,
  updateArchiveUnarchiveLocation,
  editLocationDefault,
} from 'permissions/account';

import { allRoles } from 'permissions/general';

const actionsListData: any = [
  {
    label: 'general:actions.edit_location',
    icon: '#icon-edit',
    class: '',
    action: 'edit',
    type: 'link',
    permissions: editLocation,
    condition(data: Object, action: Object, callback: Function): React.Node {
      return (
        data && (
          <ActionButton
            to={{
              pathname: `/accounts/${data.accountId}/location/${data.locationId}/edit`,
              state: {
                details: data.details,
                locationDetails: data.locationDetails ? data.locationDetails : {},
                titleEnd: data.titleEnd,
                accountId: data.accountId,
                locationId: data.locationId,
              },
            }}
            action={action}
            data={data}
          />
        )
      );
    },
  },
  {
    label: 'general:actions.assign_user_plural',
    icon: '#icon-users',
    class: '',
    action: 'assignUsers',
    permissions: updateAssignUsersToLocation,
    condition(data: Object, action: Object, callback: Function): React.Node {
      const vData = data.locationDetails ? data.locationDetails : data.details;
      return <ActionButton data={vData} action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.remove_user_plural',
    icon: '#icon-users',
    class: '',
    action: 'removeUsers',
    permissions: updateAssignUsersToLocation,
    condition(data: Object, action: Object, callback: Function): React.Node {
      const vData = data.locationDetails ? data.locationDetails : data.details;
      let total: number = 0;

      for (const key: string in vData.users_count) {
        if (vData.users_count[key]) {
          total += vData.users_count[key];
        }
      }

      return total > 0 ? (
        <ActionButton vData={vData} action={action} onActionDrawer={callback} />
      ) : null;
    },
  },
  {
    label: 'general:actions.archive_location',
    icon: '#icon-archive',
    class: '',
    action: 'archiveLocation',
    permissions: updateArchiveUnarchiveLocation,
    condition(data: Object, action: Object, callback: Function): React.Node {
      const vData = data.locationDetails ? data.locationDetails : data.details;
      return (
        !vData.archived_at && (
          <ActionButton data={vData} action={action} onActionDrawer={callback} />
        )
      );
    },
  },
  {
    label: 'general:actions.unarchive_location',
    icon: '#icon-unarchive',
    class: '',
    action: 'unarchiveLocation',
    permissions: updateArchiveUnarchiveLocation,
    condition(data: Object, action: Object, callback: Function): React.Node {
      const vData = data.locationDetails ? data.locationDetails : data.details;
      return (
        vData.archived_at && <ActionButton data={vData} action={action} onActionDrawer={callback} />
      );
    },
  },
  {
    label: 'general:actions.start_audit_from_locations',
    icon: '#icon-approve',
    class: '',
    action: 'startAuditByLocations',
    permissions: auditLocation,
    condition(data: Object, action: Object, callback: Function): React.Node {
      const vData = data.locationDetails ? data.locationDetails : data.details;
      return <ActionButton data={vData} action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.mark_as_default_location',
    icon: '#icon-radio-button-unchecked',
    action: 'markAsDefaultLocation',
    permissions: editLocationDefault,
    condition(data: Object, action: Object, callback: Function): React.Node {
      const renderButtonIf =
        data.details.asset_request_location_type === 'customer' &&
        data.details.is_default === false;
      return (
        renderButtonIf && <ActionButton data={data} action={action} onActionDrawer={callback} />
      );
    },
  },
  {
    label: 'general:actions.unmark_as_default_location',
    action: 'unmarkAsDefaultLocation',
    icon: '#icon-radio-button-checked',
    permissions: editLocationDefault,
    condition(data: Object, action: Object, callback: Function): React.Node {
      const renderButtonIf =
        data.details.asset_request_location_type === 'customer' && data.details.is_default === true;
      return (
        renderButtonIf && <ActionButton data={data} action={action} onActionDrawer={callback} />
      );
    },
  },
];

export default actionsListData;
